import { RuleConsequenceCreateObjectAllOf } from '@innovatm/js-rule-editor/src/backend';
import { Box, FormControlLabel, TextField } from '@mui/material';
import { TypographyProps } from '@mui/material/Typography';
import { Field, FieldProps } from 'formik';
import { memo } from 'react';

import { NumberOperand, ResourceManagerRule } from '../../../backend';

export const ScoreField = memo(function ScoreField() {
    return (
        <Field name="consequence.objectFields">
            {({
                field,
                form: { setFieldValue },
            }: FieldProps<RuleConsequenceCreateObjectAllOf['objectFields'], ResourceManagerRule>) => (
                <Box key={'score'} mb={1}>
                    <FormControlLabel
                        componentsProps={{
                            typography: { minWidth: 250, textAlign: 'right', marginRight: 2 } as TypographyProps,
                        }}
                        labelPlacement={'start'}
                        label={'score'}
                        control={
                            <TextField
                                id="select-type"
                                onChange={e =>
                                    setFieldValue('consequence.objectFields', {
                                        ...field.value,
                                        score: { type: 'NumberOperand', value: Number(e.target.value) },
                                    })
                                }
                                type="number"
                                variant="outlined"
                                autoFocus={!(field.value['score'] as NumberOperand)?.value}
                                value={(field.value['score'] as NumberOperand)?.value}
                            />
                        }
                    />
                </Box>
            )}
        </Field>
    );
});
